import React from 'react';
import Viewport from '../shared/viewport';
import Canvas from './canvas';

export const PREVIEW_MODE_CANVAS = 'canvas';
export const PREVIEW_MODE_VIEWPORT = 'viewport';
export const PREVIEW_MODE_LEFT_RIGHT = 'left-right';
export const PREVIEW_MODE_TOP_BOTTOM = 'top-bottom';

function PreviewTab({ name, label, previewMode, onChangePreviewMode }) {
  return (
    <div className={`panel__tab${previewMode === name ? ' active' : ''}`} onClick={() => onChangePreviewMode(name)}>
      {label}
    </div>
  );
}

export default function Preview({
  world,
  environment,
  version,
  assetLibrary,
  assetGhost,
  selection,
  activeLayer,
  previewMode,
  onChangePreviewMode,
  onSelectCells,
  onSelectEntity,
  onPlaceAsset,
  onMoveCells,
  onDuplicateCells,
}) {
  return (
    <div className="preview">
      <div className="panel__tabs">
        <PreviewTab name={PREVIEW_MODE_CANVAS} label="Canvas" previewMode={previewMode} onChangePreviewMode={onChangePreviewMode} />
        <PreviewTab name={PREVIEW_MODE_VIEWPORT} label="Preview" previewMode={previewMode} onChangePreviewMode={onChangePreviewMode} />
        <PreviewTab
          name={PREVIEW_MODE_LEFT_RIGHT}
          label="Left / Right"
          previewMode={previewMode}
          onChangePreviewMode={onChangePreviewMode}
        />
        <PreviewTab
          name={PREVIEW_MODE_TOP_BOTTOM}
          label="Top / Bottom"
          previewMode={previewMode}
          onChangePreviewMode={onChangePreviewMode}
        />
      </div>
      {previewMode === PREVIEW_MODE_CANVAS && (
        <Canvas
          world={world}
          assetGhost={assetGhost}
          selection={selection}
          activeLayer={activeLayer}
          onSelectCells={onSelectCells}
          onPlaceAsset={onPlaceAsset}
          onMoveCells={onMoveCells}
          onDuplicateCells={onDuplicateCells}
        />
      )}
      {previewMode === PREVIEW_MODE_VIEWPORT && (
        <Viewport
          world={world}
          environment={environment}
          version={version}
          assetLibrary={assetLibrary}
          selection={selection}
          onSelectCells={onSelectEntity}
          controlsEnabled={true}
          grid={true}
        />
      )}
      {previewMode === PREVIEW_MODE_LEFT_RIGHT && (
        <div className="preview__left-right">
          <Viewport
            world={world}
            environment={environment}
            version={version}
            assetLibrary={assetLibrary}
            selection={selection}
            onSelectEntity={onSelectEntity}
            controlsEnabled={true}
            grid={true}
          />
          <Canvas
            world={world}
            assetGhost={assetGhost}
            selection={selection}
            activeLayer={activeLayer}
            onSelectCells={onSelectCells}
            onPlaceAsset={onPlaceAsset}
            onMoveCells={onMoveCells}
            onDuplicateCells={onDuplicateCells}
          />
        </div>
      )}
      {previewMode === PREVIEW_MODE_TOP_BOTTOM && (
        <div className="preview__top-bottom">
          <Viewport
            world={world}
            environment={environment}
            version={version}
            assetLibrary={assetLibrary}
            selection={selection}
            onSelectEntity={onSelectEntity}
            controlsEnabled={true}
            grid={true}
          />
          <Canvas
            world={world}
            assetGhost={assetGhost}
            selection={selection}
            activeLayer={activeLayer}
            onSelectCells={onSelectCells}
            onPlaceAsset={onPlaceAsset}
            onMoveCells={onMoveCells}
            onDuplicateCells={onDuplicateCells}
          />
        </div>
      )}
    </div>
  );
}
